import React, { JSXElementConstructor, ReactElement } from "react";
import { NoDataComponent } from "../../../../../ds";
import { PaymentOrderResponse } from "../../../business";
import { PaymentOrdersPageFactory } from "../interfaces";
import { PaymentOrdersList } from "../screens/components";

export class PaymentOrdersPageFactoryImpl implements PaymentOrdersPageFactory {
    create(paymentOrdersData: PaymentOrderResponse): ReactElement<any, string | JSXElementConstructor<any>> {
        if (!paymentOrdersData?.success) return <NoDataComponent />;
        return <PaymentOrdersList response={paymentOrdersData.response} />
    }
}